import { useMemo, useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import EventCard from "@/components/base/EventCard";
import { events, categories } from "@/mocks/gossip";

export default function EventGrid() {
  const [filter, setFilter] = useState<string>("all");

  const tabs = useMemo(
    () => [{ slug: "all", name: "全部" }, ...categories.map((c) => ({ slug: c.slug, name: c.name }))],
    []
  );

  const list = useMemo(
    () => (filter === "all" ? events : events.filter((e) => e.categorySlug === filter)),
    [filter]
  );

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="深扒复盘"
          title="每一个瓜，都按时间顺序重新排好"
          desc="不做片段式转述。我们从最早的可核实节点开始，把背景、导火索、发酵过程与当前状态连成一条完整的时间线。"
          actionLabel="进入复盘档案库"
          actionTo="/events"
        />

        <div className="mt-8 flex flex-wrap gap-2">
          {tabs.map((t) => (
            <button
              key={t.slug}
              type="button"
              onClick={() => setFilter(t.slug)}
              className={`rounded-md px-4 py-2 font-label text-sm transition-colors cursor-pointer whitespace-nowrap ${
                filter === t.slug
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-300 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {t.name}
            </button>
          ))}
        </div>

        {list.length === 0 ? (
          <div className="mt-10 rounded-lg border border-dashed border-background-300 bg-background-100 p-12 text-center">
            <i className="ri-inbox-line text-3xl text-foreground-400"></i>
            <p className="mt-3 font-label text-sm text-foreground-600">
              该分类下暂无复盘档案，换个分类看看吧。
            </p>
          </div>
        ) : (
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {list.map((e, idx) =>
              idx === 0 && filter === "all" ? (
                <div key={e.id} className="md:col-span-2 lg:col-span-3">
                  <EventCard event={e} variant="wide" />
                </div>
              ) : (
                <EventCard key={e.id} event={e} />
              )
            )}
          </div>
        )}
      </div>
    </section>
  );
}